export default __webpack_public_path__ + "static/media/prize-3.f413a2fc.webp";